import React from 'react';

const VainillaDialog = (props) => {

	var tipo = props.tipo ?? "success";
	var show = props.show ?? false;
	var title = props.title;
	var body = props.body;
	var funct = props.funct;
	var respYes = props.respYes ?? "Aceptar";
	var respNot = props.respNot;
	var size = props.size ?? "m";

	if (props.data) {
		tipo = props.data.tipo ?? tipo;
		show = props.data.show ?? show;
		title = props.data.title ?? title;
		body = props.data.body ?? body;
		funct = props.data.funct ?? funct;
		respYes = props.data.respYes ?? respYes;
		respNot = props.data.respNot ?? respNot;
		size = props.data.size ?? size;
	}


	if (size.toLowerCase() !== 's' && size.toLowerCase() !== 'm' && size.toLowerCase() !== 'l' && size.toLowerCase() !== 'xl') size = 'm';
	var sizes = { 's': 'bw-400 p-3 ', 'm': 'bw-600 p-4 ', 'l': 'bw-900 p-4', 'xl': 'bw-1200 p-3 ' }


	return (
		<div className={show && (body || title) ? "frontal-blur-transparent-sm" : "hide"}>
			<div className="row justify-content-center p-4 pt-5">

				<div className={sizes[size.toLowerCase()] + " shadow rounded text-center bg-white mt-5"}>

					{title && <p className={
						tipo.toLowerCase() == "success" ? "h2 text-certus" :
							tipo.toLowerCase() == "warning" ? "h2 text-warning" :
								tipo.toLowerCase() == "error" ? "h2 text-danger" : "h2 text-dark"
					}>{title}</p>}

					{body && <div className="col-log-12 h6 text-300 mt-4 mb-4" style={{ whiteSpace: 'pre-wrap' }}>{body}</div>}

					<div className="row justify-content-center">
						<div className="col-lg-6 text-center">
							<button
								className="btn btn-light border border-danger shadow mt-3"
								onClick={() => { if (funct) funct(true) }}>{respYes}</button>
						</div>
						{
							respNot &&
							<div className="col-lg-6 text-center">
								<button className="btn btn-light shadow mt-3 border border-info"
									onClick={() => { if (funct) funct(false); }}> {respNot}
								</button>
							</div>
						}

					</div>
				</div>
			</div>
		</div>
	);
}

export default VainillaDialog;